export default "__VITE_ASSET__BzPlVNXc__"